export default {"src":"/_next/static/media/favicon.32cf3e2a.ico","height":16,"width":16,"blurWidth":0,"blurHeight":0};